interface State {
    modalMode: string | null;
    menuMode: string | null;
    focusMode: string | null;
}

const initialState: State = {
    modalMode: null,
    menuMode: null,
    focusMode: null
};

const state: State = {
    ...initialState
};

const getters = {
    modalMode: (state: State) => state.modalMode,
    menuMode: (state: State) => state.menuMode,
    focusMode: (state: State) => state.focusMode
};

const mutations = {
    setModalMode(state: State, mode: string) {
        state.modalMode = mode;
    },
    setMenuMode(state: State, mode: string) {
        state.menuMode = mode;
    },
    setFocusMode(state: State, mode: string) {
        state.focusMode = mode;
    }
};

const actions = {
    setModalMode({ commit }: any, mode: string) {
        commit('setModalMode', mode);
    },
    setMenuMode({ commit }: any, mode: string) {
        commit('setMenuMode', mode);
    },
    setFocusMode({ commit }: any, mode: string) {
        commit('setFocusMode', mode);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};